import React from "react";
import { FaInstagram, FaEnvelope, FaGlobe, FaPhone } from "react-icons/fa"; // Importación de iconos
import "./LocationContact.css";

const UbicacionContacto = () => {
  return (
    <section className="ubicacion-contacto-container">
      <div className="ubicacion-contacto-content">
        <div className="ubicacion-contacto-info">
          <h3 className="ubicacion-contacto-subtitulo">UBICACIÓN</h3>
          <p className="ubicacion-contacto-p">
            Uno de los edificios más emblemáticos de Dubái: The Opus Tower Business Bay
          </p>

          <h3 className="ubicacion-contacto-subtitulo">CONTACTO</h3>
          <div className="ubicacion-contacto-item">
            <FaInstagram className="ubicacion-contacto-icon" />
            <p className="ubicacion-contacto-text">thorneglobalrealestate</p>
          </div>
          <div className="ubicacion-contacto-item">
            <FaEnvelope className="ubicacion-contacto-icon" />
            <p className="ubicacion-contacto-text">info@thorneglobalrealestate.com</p>
          </div>
          <div className="ubicacion-contacto-item">
            <FaGlobe className="ubicacion-contacto-icon" />
            <p className="ubicacion-contacto-text">www.thorneglobalrealestate.com</p>
          </div>
          <div className="ubicacion-contacto-item">
            <FaPhone className="ubicacion-contacto-icon" />
            <p className="ubicacion-contacto-text">+971 585582100</p>
          </div>
        </div>

        <div className="ubicacion-contacto-mapa">
          <iframe
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3610.430819341517!2d55.26449807483709!3d25.188689832046276!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3e5f69cd8f669cbf%3A0x1086c324a5946077!2sThe%20Opus%20by%20OMNIYAT%20designed%20by%20Zaha%20Hadid!5e0!3m2!1ses-419!2sar!4v1734722793021!5m2!1ses-419!2sar"
            width="100%"
            height="450"
            style={{ border: 0 }}
            allowFullScreen
            loading="lazy"
            title="The Opus Tower location in Dubai"
          />
        </div>
      </div>
    </section>
  );
};

export default UbicacionContacto;